import { render } from "./InviteUserCard.vue?vue&type=template&id=4b90555b&ts=true"
import script from "./InviteUserCard.vue?vue&type=script&lang=ts"
export * from "./InviteUserCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Welcome/InviteUserCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b90555b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b90555b', __exports__)) {
    api.reload('4b90555b', __exports__)
  }
  
  module.hot.accept("./InviteUserCard.vue?vue&type=template&id=4b90555b&ts=true", () => {
    api.rerender('4b90555b', render)
  })

}


export default __exports__